export enum MetricsType {
    INCOME_STATEMENT = "incomeStatement",
    BALANCE_SHEET = "balanceSheet",
}
